import React from 'react';
import PropTypes from 'prop-types';
import { Provider, inject, observer } from 'mobx-react';
import { MemberWeddingClient } from '../libs/wws-api-client';
import get from 'lodash/get';
import GuestListStore from '~/glm/models/guest-list-store';
import UserStore from '~/glm/models/user-store';
import AnalyticsStore from '~/glm/models/analytics-store';
import GdsUiState from './models/gds/gds-ui-state';
import { withRouter } from 'react-router-dom';

const memberWeddingClient = new MemberWeddingClient();

@withRouter
@inject('userStore')
@observer
class InitGuestList extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    userStore: PropTypes.instanceOf(UserStore),
  };

  constructor(props, context) {
    super(props, context);
    this.initialize();
  }

  initialize = () => {
    const { userStore } = this.props;
    this.guestListStore = new GuestListStore();
    this.gdsUiState = new GdsUiState(userStore, this.props.history, this.guestListStore.gdsEvents);

    GdsUiState.prototype.guestCollection = this.guestListStore.households;

    this.analyticsStore = new AnalyticsStore(this.gdsUiState, this.guestListStore);

    this.analyticsStore.page();

    this.initGuestListPromise = InitGuestList.fetchGuestListData(
      this.guestListStore,
      this.gdsUiState,
      userStore,
      this.analyticsStore
    );

    InitGuestList.fetchMemberWedding(this.gdsUiState);
  };

  static fetchMemberWedding(gdsUiState) {
    return memberWeddingClient.getMemberWeddingUiSettings().then(response => {
      const data = get(response, 'data.data');
      if (data) {
        const shouldShowMessagingHub = get(data, 'weddingWebsite.uiSetting.showMessagingHub');
        gdsUiState.setShowMessagingHub(shouldShowMessagingHub);
      }
    });
  }

  static fetchGuestListData(guestListStore, gdsUiState, userStore, analyticsStore) {
    return guestListStore
      .fetchCollections()
      .then(gdsUiState.setupReactionsOnGuestListChanges)
      .then(() => gdsUiState.setupInitialEvents(guestListStore.gdsEvents.nonReceptionEvents.map(e => e.id)))
      .then(() => analyticsStore.identifyUser(userStore.legacyUserId));
  }

  render() {
    return (
      <Provider
        guests={this.guestListStore.guests}
        events={this.guestListStore.events}
        invitations={this.guestListStore.invitations}
        gdsHouseholds={this.guestListStore.households}
        gdsEvents={this.guestListStore.gdsEvents}
        guestListStore={this.guestListStore}
        analyticsStore={this.analyticsStore}
        gdsUiState={this.gdsUiState}
        initGuestListPromise={this.initGuestListPromise}
      >
        <React.Fragment>
          {this.gdsUiState.showAppDialog && this.gdsUiState.appDialog}
          {this.props.children}
        </React.Fragment>
      </Provider>
    );
  }
}

export default InitGuestList;
